module.exports = __webpack_public_path__ + "img/logo_header_color.cda15d7a.png";